module.exports = __webpack_public_path__ + "img/9a61e17.jpg";